import type {
	Export,
	ExportModel,
	ExportStorePayload,
	ExportUpdatePayload,
} from '@/models/Export/Model'
import Api from '@/helpers/models/Api'
import type { LaravelPaginationResponse } from '@/interfaces/models/Laravel'
import type { Build } from '../Build/Model'
import type { RepositoryConfig } from '../RepositoryConfig/Model'
import type { AxiosResponse } from 'axios'
import axios from 'axios'
import type { CodeDelivery } from '@/models/CodeDelivery/Model'

const apiUrl = import.meta.env.VITE_API_URL

export default class ExportsApi extends Api<
	ExportModel,
	LaravelPaginationResponse<ExportModel>,
	ExportStorePayload,
	ExportUpdatePayload
> {
	route = 'exports'

	async update(): Promise<any> {
		throw new Error('Not implemented')
	}

	async updateRelation(): Promise<any> {
		throw new Error('Not implemented')
	}

	async destroy(): Promise<any> {
		throw new Error('Not implemented')
	}

	async store(): Promise<any> {
		throw new Error('Not implemented')
	}

	async export(params: {
		build_id: Build['id']
		delivery:
			| {
					type: 'git'
					repository_config_id: RepositoryConfig['id']
			  }
			| {
					type: 'zip'
			  }
	}): Promise<AxiosResponse<{ delivery: CodeDelivery; export: Export }>> {
		return await axios.post(`${apiUrl}/${this.route}`, params)
	}
}
